import { http, HttpResponse } from 'msw';

export const getSigningStatusHandler = [
    http.get('*/api/cl_loanapp_proxy_service/v1/:countryCode/application/:arn/signing_status', async () => {
        return HttpResponse.json({
            signingStatus: 'CREATED', //COMPLETE
            waitingFor: 'MAIN', //NONE | MAIN | CO
        });
    }),
];
